import { getToken } from "../../../shared/utils/common";


export class CommandCreateFolder {
    async run(organizationId: number, folderName: string, folderType: string) {
       
            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/folders/`
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `},
                    body: JSON.stringify({name: folderName, type: folderType})
                    })
                .then(response =>  response.json())
                .then(json => json)
                .catch(err => console.log(err));
                if(response) {
                    return response;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        }

}
